import { initMap, equalCols, getCookie } from '../functions';
import Swal from 'sweetalert2'

$(document).ready(function() {

	const eventTickets = {
        isLoading: false,
        init() {
            $(document).on('click', '.event-ticket-confirm-btn', this, this.confirm);
        },
		confirm(event) {
			const _this = event.data;
			event.preventDefault();

			let id = $(this).data('id');

			if (_this.isLoading) {
                return false;
            }

            $('.ticket-confirm-form').find('.form-control').removeClass('is-invalid');
            $('#ticket-confirm-terms').removeClass('is-invalid');

            var error = false;
            if ($('#ticket-confirm-first-name').val() == '') {
                $('#ticket-confirm-first-name').addClass('is-invalid');
                error = true;
            }
            if ($('#ticket-confirm-last-name').val() == '') {
                $('#ticket-confirm-last-name').addClass('is-invalid');
                error = true;
            }
            if ($('#ticket-confirm-email').val() == '') {
                $('#ticket-confirm-email').addClass('is-invalid');
                error = true;
            }
            if (!$('#ticket-confirm-terms').is(":checked")) {
				$('#ticket-confirm-terms').addClass('is-invalid');
				error = true;
			}

            if (error) {
                return false;
            }

			//Loading...
            _this.isLoading = true;
			let element = this;
			$(element).find('i').show();

			var values='';
            values+='id=' + id;
            values+='&first_name=' + $('#ticket-confirm-first-name').val();
            values+='&last_name=' + $('#ticket-confirm-last-name').val();
            values+='&email=' + $('#ticket-confirm-email').val();
            values+='&phone=' + $('#ticket-confirm-phone').val();
            values+='&company=' + $('#ticket-confirm-company').val();
            values+='&_token=' + $('meta[name="csrf-token"]').attr("content");
			$.ajax({
                type: "POST",
                url: baseURLlang + 'ticket/confirm',
                data: values,
                success: function(response) {
					_this.isLoading = false;
					$(element).find('i').hide();

					if (response.status == 1) {
                        $('#ticket-confirm-terms').prop('checked', false);
                        $('.ticket-confirm-form').find('.form-control').val('');

                        if (response.paylink != null && response.paylink != '') {
                            Swal.fire({
                                html: '<i class="fas fa-spinner fa-spin"></i>',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: false,
                                showCancelButton: false,
                            });
                            window.location.href = response.paylink;
                            return false;
                        }

						Swal.fire({
							// icon: 'success',
							// title: 'Success!',
							text: response.message
						});

						return false;
					}

                    Swal.fire({
                        // icon: 'error',
                        // title: 'Error!',
                        text: response.message
                    });
	            },
                error(error) {
                    _this.isLoading = false;
					$(element).find('i').hide();
                },
	        });
		}
    };

    if ($('.event-ticket-confirm-btn').length) {
        eventTickets.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/tickets.js